// src/components/Sections/EventsSection/EventsSection.jsx

import React from 'react';
import './EventsSection.scss';

import eventsScreenshot from '../../../assets/images/marketing/ttg-events-phone.png';
import clubScreenshot from '../../../assets/images/marketing/ttg-around-club-phone.png';

import useInView from '../../../hooks/useInView';

export default function EventsSection() {
  const {
    ref,
    isVisible
  } = useInView({
    threshold: 0.2
  });

  return (
    <section
      id="events"
      ref={ref}
      className={`
        clubhouse-v4
        section-v2
        motion-section
        ${isVisible ? 'is-visible' : ''}
      `}
    >
      <div className="container clubhouse-v4__layout">
        <div className="clubhouse-v4__copy motion-copy">
          <p className="eyebrow">
            The Clubhouse
          </p>

          <h2>
            The clubhouse goes beyond the app.
          </h2>

          <p>
            Follow the people you play with and celebrate their rounds in
            the digital Clubhouse. As the founding community grows, the goal
            is to bring members together through rounds, socials, watch
            parties, and simulator gatherings.
          </p>

          <div className="clubhouse-v4__tags">
            <span>
              Planned member rounds
            </span>

            <span>
              Planned social nights
            </span>

            <span>
              Planned watch parties
            </span>

            <span>
              Member recognition
            </span>
          </div>

          <a
            href="#launch"
            className="text-link"
          >
            See the launch plan

            <span aria-hidden="true">
              →
            </span>
          </a>
        </div>

        <div className="clubhouse-v4__visual">
          <span
            className="clubhouse-v4__ghost"
            aria-hidden="true"
          >
            CLUBHOUSE
          </span>

          <figure className="clubhouse-v4__phone clubhouse-v4__phone--club">
            <img
              src={clubScreenshot}
              alt="The Tour Golfers Around the Club recognition feed"
              loading="lazy"
            />
          </figure>

          <figure className="clubhouse-v4__phone clubhouse-v4__phone--events">
            <img
              src={eventsScreenshot}
              alt="The Tour Golfers Club Events screen"
              loading="lazy"
            />
          </figure>

          <div className="clubhouse-v4__ticket">
            <div>
              <small>
                The Tour Golfers
              </small>

              <strong>
                Member Social
              </strong>

              <span>
                Clubhouse Event
              </span>
            </div>

            <b>
              TTG
            </b>
          </div>
        </div>
      </div>
    </section>
  );
}